import { Paragraph, Spacing } from "@sicredi/react";
import { CardTracking } from "../CardTracking";
import { ButtonLinkChevronRight } from "#/components/ButtonLinkChevronRight";
import { ITrackingComponents } from "../model";
import styles from "./styles.module.scss";

export const SimulacaoTracking: React.FC<ITrackingComponents> = ({
  state,
  paragraphSize,
  onClick,
  isIconClock,
}) => {
  return (
    <div>
      <CardTracking title="Simulação" state={state} isIconClock={isIconClock}>
        {!isIconClock && (
          <>
            <Paragraph size={paragraphSize(state)} weight="normal">
              Seu contrato foi criado.
            </Paragraph>

            <div className={styles.button_container}>
              <ButtonLinkChevronRight
                onClick={onClick}
                text="Confira o regulamento"
              />
            </div>
          </>
        )}
        {isIconClock && <Spacing appearance="x-large" />}
      </CardTracking>
    </div>
  );
};
